import React ,{useState,useEffect}from 'react'
import "./otp.css";
import leftArrow from "../assets/images/leftArrow.svg";
import alert from "../assets/images/alert.svg";

import { Trans, useTranslation } from "react-i18next";
function Otp(props) {
  const { t, i18n } = useTranslation();
    let [otpValue, setOtpValue] = useState("");
    let [otpStyle, setOtpStyle] = useState({
        background: "#FFFFFF",
        border: "1px solid #C4CDD5",
        boxSizing: "border-box",
        borderRadius: "8px",
        padding: "13px",
        fontSize: "18px",
        fontWeight: "bold",
        lineHeight: "24px",
        color: "#000",
        outline: "none",
        width: "100%",
        height: "48px",
        isDesktopClick: false,
        isDesktopBackClick: false,
        marginTop:"10px",
    });
    let [otpStyleError, setOtpStyleError] = useState({
        background: "#FFFFFF",
        border: "1px solid #F15123",
        boxSizing: "border-box",
        borderRadius: "8px",
        padding: "13px",
        fontSize: "18px",
        fontWeight: "bold",
        lineHeight: "24px",
        color: "#000",
        outline: "none",
        width: "472px",
        height: "48px",
        isDesktopClick: false,
        isDesktopBackClick: false
    });
    let [time, setTime] = useState(14);
    let [verifyOtpBtnEnabled, setVerifyOtpBtnEnabled] = useState(false);

    useEffect(() => {
        let timer;
        if (time > 0) {
            timer = setTimeout(() => {
                setTime(time - 1);
            }, 1000);
        }
        return () => clearTimeout(timer);
    }, [time]);

    useEffect(() => {
        otpValue.length == 4
            ? setVerifyOtpBtnEnabled(true)
            : setVerifyOtpBtnEnabled(false);
    }, [otpValue]);

    const keyPressed = (event) => {
        var code = event && (event.keyCode || event.which);
        if (code === 13) {
            handleButtonClick();
        }
    }

    const handleButtonClick = () => {
        if (otpValue.length != 4) {
            props.verifyOtpErrorChangeAction(true)
            return
        }
        const reqObj = {
            otp: otpValue,
            countryExt: props.CountryCode,
            sessionId: props.generateOtp.sessionId,
            orgId: props.orgId
        };
        Object.assign(
            reqObj, props.loginState == 0 ? { mobile: props.mobile }  : { email: props.email }
        );
        props.verifyOtpAction(reqObj);
    };

    return (
        <div className="otp-container">
        <button
            className="otp-back-button"
            onClick={() => {
                props.setStatusAction("AccountLogin");
            }}
        >
            <img src={leftArrow} alt="" style={{ marginRight: "8px" }} />
            <label style={{ cursor: "pointer" }}>{t("Routes.Login.Otp.back", "Back")}</label>
        </button>
        <p className="otp-heading">
           {t("Routes.Login.Otp.VerifyMobileNumber"," Verify your")} {props.loginState == 0 ? t("Routes.Login.Otp.VerifyMobileNumber2","mobile number") : t("Routes.Login.Otp.VerifyMobileNumber3","email address")}
        </p>
        <p className="otp-subheading">
            <Trans i18nkey="Routes.Login.Otp.VerifCodeSent">
            Please enter the 4-digit verification code sent to you at
            </Trans>
            <span className="otp-sent-detail">{props.loginState == 0 ? `+${props.CountryCode}-${props.mobile}` : `${props.email}`}</span>
        </p>
        <p className="otp-texts">{t("Routes.Login.Otp.EnterOtpHere", "Enter OTP here")}</p>
        <input
        id="otp_input"
            onChange={e => {
                const regex = /^[0-9\b]+$/;
                const otp = e.target.value
                if (
                    (otp === "" ||
                        regex.test(otp)) &&
                    otp.length < 5
                ) {
                    props.verifyOtpErrorChangeAction(false)
                    setOtpValue(otp);
                    props.setOtpAction(otp);
                }
            }}
            onKeyPress={(event) => keyPressed(event)}
            shouldAutoFocus={true}
            value={otpValue}
            style={props.verifyOtpError ? otpStyleError : otpStyle}
            autoFocus
        />
        {props.verifyOtpError ? (
            <div className="otp-error">
                <img src={alert} alt="" style={{ marginRight: "4px" }} />
                <label className="otp-error-message">
                  {otpValue.length != 4 ? t("Routes.Login.Otp.EnterValidOtp", "Please enter a valid OTP."): t("Routes.Login.Otp.InvalidOtp","Invalid OTP. Please check and try again.")}
                </label>
            </div>
        ) : null}

        {time !== 0 && (
            <div className="otp-waiting">
               {t("Routes.Login.Otp.ResendOtpIn", " Resend otp in")}{' '}{time < 10 ? "0" : ""}
                {time} {t("Routes.Login.Otp.Seconds", "seconds")}
            </div>
        )}
        {time === 0 && (
            <div
                className="otp-resend"
                onClick={() => {
                    props.handleGenerateOtp();
                    setTime(14)
                }}
            >
                <div style={{ marginLeft: "8px" }}>
                    {t("Routes.Login.Otp.SendOtpAgain", "Send OTP again")}
                </div>
            </div>
        )}
    <div className="otp-footer">
        <button
            className={verifyOtpBtnEnabled
                    ? "otp-button-enabled"
                    : "otp-button-disabled"
            }
            onClick={handleButtonClick}
            data-cy="login_verify"
        >
            {t("Routes.Login.Otp.VerifyOtp", "Verify OTP")}
        </button>
        </div>
    </div>
    )
}

export default Otp
